import { useState } from 'react';

import DatePicker from '@components/date-picker/DatePicker';
import Icon from '@components/icon/Icon';
import Input from '@components/input/Input';
import Label from '@components/label/Label';
import { formatISODate } from '@utils/date';

import theme from '../../../themes/colors';

interface MemberStartDateProps {
  startDate: string;
  onStartDateChange: (date: string) => void;
  maxLimitDate?: Date;
  isDisabled?: boolean;
}

const MemberStartDate = ({
  startDate,
  onStartDateChange,
  maxLimitDate,
  isDisabled
}: MemberStartDateProps) => {
  const [isStartDatePickerVisible, setIsStartDatePickerVisible] =
    useState<boolean>(false);

  return (
    <div className="gap-4">
      <Label label="Fee Collection Start Date" />
      <Input
        readOnly
        leftIconName="calendar"
        value={startDate ? formatISODate({ date: startDate }) : ''}
        onClick={() => {
          setIsStartDatePickerVisible(true);
        }}
        placeholder="Select payment start day"
        disabled={isDisabled}
      />
      <div className="mt-1 flex items-center gap-1 text-xs text-cofeeGreyBlue6">
        <Icon name="alert-circle" stroke={theme.subText} size="16" />
        If not given, the start date of group will be taken into account
      </div>
      {isStartDatePickerVisible && (
        <div
          className="fixed left-1/2 top-1/2 z-50 -translate-x-1/2 -translate-y-1/2 rounded-lg border bg-theme shadow-lg"
          id="start-date-calendar"
        >
          <DatePicker
            confirmButtonLabel="Apply"
            confirmButtonStyle="text-primary"
            handleConfirm={(date: string) => {
              onStartDateChange(date);
              setIsStartDatePickerVisible(false);
            }}
            cancelButtonLabel="Cancel"
            handleCancel={() => {
              setIsStartDatePickerVisible(false);
            }}
            selectedDate={(startDate && new Date(startDate)) || new Date()}
            calendarStyle="!bg-bgBase"
            title="Select Start Date"
            isMaxDateRequired={!!maxLimitDate}
            maxDate={maxLimitDate}
          />
        </div>
      )}
    </div>
  );
};

export default MemberStartDate;
